module.exports = __webpack_public_path__ + "static/media/apolloHospitalsTestimonialIcon.affcc439.svg";